/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component } from 'react';
import { connect } from 'react-redux';

// import { Footer } from 'features/components/base/layouts';
import { SaleCardViewDataTable } from 'shared/sale-card-view-datatable/SaleCardViewDataTable';
import { bgTransparantBlack } from 'shared/images/images';
import { Form, InputGroup, FormControl, Button, FormLabel } from 'react-bootstrap';
import Helmet from 'react-helmet';
import axios from 'axios';

import store from 'features/store';

import './CategoryPage.scss';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';
import { categoryDetail } from 'shared/settings/apiconfig';
import { CityAndStateService } from 'shared/services';

/**


@Author Lakshmi

@param

@return html code for locations list

**/

class CategoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryName: this.captializeLetter(this.props.match.params.categoryname),
            subcategoryName: this.captializeLetter(this.props.match.params.subcategoryname),
            loaderForMore: false,
            filterLoading: false,
            categoryList: [],
            pageLoading: true,
            displayData: {
                "filter": [
                    {"field": "salestatus", "value": "Started", "op": "=", "join": "AND"},
                    {"field": "itemstatus", "value": "Ready", "op": "=", "join": "AND"}
                ],
                "sort": [{ "field": "itemclosetime", "direction": "asc" }],             
            },
            isshippable: false,
            ispickuponly: false,
            reloadItems: false,
            keywords: "",
            categoryInfoData: "",
            saleCardView: false,
            stateList: [],
            selectedState: ""
        }
    }

    componentDidMount() {
        this.getCategoryUrlDetails();
        this.getStateList();
    }

    captializeLetter = (data) => {
        const capitalized = data?.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }

    getCategoryUrlDetails = () => {
        axios.post(getBuyersUrl(`${categoryDetail}/${this.props.match.params.subcategoryname}`), {data: {"urlCode": this.props.match.params.subcategoryname}}, getBuyerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.setState({
                    categoryInfoData: JSON.parse(response.data.data[0]['textcontent'])
                })
                if(this.state.categoryInfoData.parentCategory) {
                    this.state.displayData.filter.push({"field": "categoryGroup", "value": this.state.categoryInfoData.parentCategory, "op":"=", "join": "AND"})
                } 
                if(this.state.categoryInfoData.subCategory) {
                    if((this.state.categoryInfoData.subCategory).includes("|")){
                        let subCategoryArray = this.state.categoryInfoData.subCategory.split("|")
                        subCategoryArray.map((elem) => {
                            this.state.displayData.filter.push({"field": "category", "value": elem, "op":"=", "join": "OR"})   
                        })
                    } else {
                        this.state.displayData.filter.push({"field": "category", "value": this.state.categoryInfoData.subCategory, "op":"=", "join": "AND"})
                    }
                }
                this.defaultFilterValue = this.state.displayData; 
                this.setState({
                    saleCardView: true,
                    displayData: this.defaultFilterValue
                })
            }
        }).catch(error => {
        });
    }

    getStateList = () => {
        CityAndStateService.getStateList().then(
            stateList => {
                this.setState({
                    stateList: stateList.data.data
                });
            }
        ).catch((error) => {
            // TODO: Error message handle
        });
    }
   
    getItemsList = (event) => {
        this.setState({
            noData: event.length === 0,
            loaderForMore: false,
            filterLoading: false,
        });
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "CategoryPage" } });
    }

    onChangeCheckbox = (event, value) => {
        this.setState({
            isshippable : event === "isshippable" ? !value : this.state.isshippable,
            ispickuponly : event === "ispickuponly" ? !value : this.state.ispickuponly
        })
    }

    setValue = (fieldName, event) => {
        this.setState({
            keywords : fieldName === "keywords" ? event.target.value : this.state.keywords,
            selectedState : fieldName === "state" ? event.target.value : this.state.selectedState
        })
    }

    searchEnable = () => {
        let searchData = JSON.parse(JSON.stringify(this.defaultFilterValue))
        let index = searchData.filter.findIndex(elem => elem.field == "isshippable")
        let value = []
        if(this.state.keywords) {
            searchData.filter.push({ "field": "title", "value": `%${this.state.keywords}%`, "op": "LIKE", "join": "OR" });
            searchData.filter.push({ "field": "tag", "value": `%${this.state.keywords}%`, "op": "LIKE", "join": "OR" });
            searchData.filter.push({ "field": "description", "value": `%${this.state.keywords}%`, "op": "LIKE", "join": "AND" });
        }
        if(this.state.isshippable || this.state.ispickuponly) {
            if(this.state.isshippable){
                value.push(1);
            }
            if(this.state.ispickuponly){
                value.push(0);
            }
            searchData.filter.push({field: "isshippable", value: [value], op: "IN", join: "AND"})
        }
        if(this.state.selectedState && this.state.selectedState != 'All') {
            searchData.filter.push({ "field": "state", value: this.state.selectedState, "op": "=", "join": "AND"})
        }
        this.setState({
            displayData: searchData
        });
    }  

    clearSearch = () => {
        this.setState({
            displayData: this.defaultFilterValue,
            keywords: '',
            isshippable: false,
            ispickuponly: false,
            selectedState: ''
        })
    }

    directUrl = (event, data) => {
        if(data == "home") {
            this.props.history.push('/');
        }
    }
   
    render() {
        return (
            <div className="category-main">
                <Helmet>
                    <title>{this.state.categoryInfoData.pagetitle}</title>
                    <meta name='description' content={this.state.categoryInfoData.metadescription} />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    <link rel="canonical" href={`https://ctbids.com`} />
                </Helmet>
                <div className="breadcrumb-section d-lg-flex align-items-center justify-content-between pd-1-5" style={{color: "#ffffff", backgroundColor: "#76616A"}}>
                    <div className="back-and-title d-md-flex align-items-center">
                        { (this.props.match.params.categoryname && this.props.match.params.subcategoryname) ? 
                            <div className="d-flex align-items-center clickable">
                                <div className="text cursor" onClick={(event)=>this.directUrl(event, 'home')}>Home</div>
                                <div className="icon">
                                    <i className="fas fa-angle-right pd-10"></i>
                                </div>
                                <div className="text">{this.state.categoryName}</div>
                                <div className="icon">
                                    <i className="fas fa-angle-right pd-10"></i>
                                </div>
                                <div className="text">{this.state.categoryInfoData['h1tag']}</div>
                            </div> : (this.props.match.params.subcategoryname || this.props.match.params.categoryname) ? 
                            <div className="d-flex align-items-center clickable">
                                <div className="text cursor" onClick={(event)=>this.directUrl(event, 'home')}>Home</div>
                                <div className="icon">
                                    <i className="fas fa-angle-right pd-10"></i>
                                </div>
                                <div className="text"><h1>{ this.state.categoryName|| this.state.subcategoryName}</h1></div>
                            </div> : 
                            <div className="d-flex align-items-center clickable">
                                <div className="text cursor" onClick={(event)=>this.directUrl(event, 'home')}><h1>Home</h1></div>
                            </div>
                        }
                    </div>
                </div>
                <div className="category-img" style={{ backgroundImage: `linear-gradient(rgb(240 240 240 / 93%), rgb(240 240 240 / 93%)), url(${bgTransparantBlack})`, color: '#000000' }}>
                    <div className="category-content text-secondary pd-10"><h1><b>{this.state.categoryInfoData['h1tag']}</b></h1></div>
                    <p className="pd-10">{this.state.categoryInfoData['h1-bodycopy']}</p>
                </div>
                <div className="pd-5">
                    <div className="d-lg-flex align-items-center filter-content js-ct jsct-sp">
                        <div className="d-flex resp-flex-column">
                            <FormLabel className="category-label center-align mr-10">Keywords: </FormLabel>
                            <Form.Control placeholder="Search all of these words" name="keywords" value={this.state.keywords} onChange={(event) => { this.setValue('keywords', event) }} style={{color: "#808080"}} />
                        </div>
                        <div className="d-flex resp-flex-column">
                            <FormLabel className="category-label center-align mr-10">State: </FormLabel>
                            <Form.Group className="mb-0">
                                <Form.Control as="select" name="location" onChange={event => this.setValue('state', event)} value={this.state.selectedState}>
                                    <option value="All">All</option>
                                    {
                                        this.state.stateList.map((state, index) => <option key={`state_${index}`} value={state.state}>{state.state}</option>)
                                    }

                                </Form.Control>
                            </Form.Group>
                        </div>
                        <div className="d-lg-flex resp-flex-column">
                            <Form.Label className="category-label center-align mr-10">
                                Location:
                            </Form.Label>
                            <div className="d-flex location-checkbox resp-flex-column">
                                <Form.Group className="multiple-checkbox mb-0 mr-10">
                                    <Form.Check custom type="checkbox" id="isshippable" name="isshippable" label="Shippable" onClick={() => this.onChangeCheckbox('isshippable', this.state.isshippable)} />
                                </Form.Group>
                                <Form.Group className="multiple-checkbox mb-0">
                                    <Form.Check custom type="checkbox" id="pickuponly" name="pickuponly" label="Pick Up Only" onClick={() => this.onChangeCheckbox('ispickuponly', this.state.ispickuponly)} />
                                </Form.Group>
                            </div>
                        </div>
                        <div className="d-flex align-items-center action-btn">
                            <div className="clickable" style={{marginRight: "15px"}} onClick={this.clearSearch}>Clear All</div>
                            <Button variant="secondary" onClick={() => this.searchEnable()}>Search</Button>
                        </div>
                    </div>
                    <div><hr className="category-hr-line"></hr></div>
                    <div className={`d-flex align-items-center justify-content-center ${this.state.noData ? 'h-75' : ''}`}>
                        <div className="large-screen-width">
                            { this.state.saleCardView ? <SaleCardViewDataTable config={{ postData: this.state.displayData }}{...this.props} getItemsList={this.getItemsList} showMoreButton 
                            addBidPrice={(this.state.pricemax || this.state.pricemin) ? true : false}></SaleCardViewDataTable> : '' }
                        </div>
                    </div>
                </div>
                <div className="description-footer" style={{ backgroundImage: `linear-gradient(rgb(255 255 255 / 85%), rgb(255 255 255 / 85%)), url(${bgTransparantBlack})`}}>
                    <div className='category-description'>
                        <div className='mb-10'>
                            <h2 className="text-secondary"><b>{this.state.categoryInfoData['h2tag-1']}</b></h2>
                            <p style={{color: "#000000"}}>{this.state.categoryInfoData['h2-bodycopy-1']}</p>
                        </div> 
                        <div className='mb-10'>
                            <h2 className="text-secondary"><b>{this.state.categoryInfoData['h2tag-2']}</b></h2>
                            <p style={{color: "#000000"}}>{this.state.categoryInfoData['h2-bodycopy-2']}</p>
                        </div> 
                        <div className='mb-10'>
                            <h2 className="text-secondary"><b>{this.state.categoryInfoData['h2tag-3']}</b></h2>
                            <p style={{color: "#000000"}}>{this.state.categoryInfoData['h2-bodycopy-3']}</p>
                        </div>
                        <div className='mb-10'>
                            <h2 className="text-secondary"><b>{this.state.categoryInfoData['h2tag-4']}</b></h2>
                            <p style={{color: "#000000"}}>{this.state.categoryInfoData['h2-bodycopy-4']}</p>
                        </div>
                    </div>
                </div>
                {/* <Footer className={`${this.props.user.profilecompleted === 1 ? 'remove-bottom' : ''}`}{...this.props} /> */}
            </div>
        );
    }
}

export default connect(state => state)(CategoryPage);